import(/* webpackMode: "eager" */ "/vercel/path0/src/app/admin-access/page.tsx");
